"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
/**
 * Type guard for undefined types
 */
function isDefined(v) {
    return !(typeof v === 'undefined');
}
exports.isDefined = isDefined;
